<template>
  <div id="app">



      <hearder ref="head"></hearder>
    <router-view :key="$route.fullPath + Date.now()"/>




      <Footer ref="foot"></Footer>




  </div>
</template>

<script>
import hearder from './components/hearder.vue'
import Footer from './components/Footer.vue'
import axios from 'axios';
export default {
  name: 'App',
  data() {
    return {
      path: "",
      message:"zh",
    }
  },
  components: {
    Footer,
    hearder,
  },
  mounted() {
    this.path = this.$route.path; /*this.path 为当前页面的路由 */

  },
  created() {
    // let that = this;
    // let pathFrom = that.$route.path;
    // if(pathFrom.startsWith("/en")){
    //   that.message = 'en';
    // } else {
    //   that.message = 'zh';
    // }
  },
  methods: {
  },
  /*监测路由的变化 */
  watch: {
    $route(to, from) {
      this.path = to.path;
      let that = this;
      let headItem = hearder.data().menuData;
      console.log(that.path)
      for(let item in headItem){
        let itemData =  headItem[item]
        if(that.path == itemData.headPath){
          console.log("head:"+ itemData.headIndex)
          hearder.data().activeIndex = itemData.headIndex;
        }
      }
      this.$refs.head.choiceEn();
      this.$refs.foot.choiceEn();

    }

  },

}
</script>

<style>
a{text-decoration: none;}
.hearder {
  border: 1px red solid;

}
body{
    background-color: aliceblue;
}
</style>



// WEBPACK FOOTER //
// src/App.vue